export const ASSETS = {
  video:
    'https://cdn.magicpatterns.com/uploads/dv38tALUpbVDh3ZeMGJYhJ/0226.mp4',
  logo: 'https://cdn.magicpatterns.com/uploads/3vx95Mfcz4QZiHvjJtgYTr/capture_260217_231741.png',
  mercadoPago:
    'https://cdn.magicpatterns.com/uploads/cK52aAb7RSGa6wHixwE7L2/mercadopago2.jpg',
  mainProduct:
    'https://cdn.magicpatterns.com/uploads/dfEDjVGJrHSHdi25jjRyxU/a-photorealistic-product-photograph-base_KJExYIC7T7ezSQAcBnxoCA_KpTGN4p-TgiDTGFU-s-_KA_hd.png',
  compraSegura:
    'https://cdn.magicpatterns.com/uploads/rqZ3wv9AeoifUcgoSYyxoy/safe-purchase-7779878_1280.png',
  garantia:
    'https://cdn.magicpatterns.com/uploads/6GVXh72hXpk5P6QipNEBqh/Selo-de-Garantia-de-7-Dias-PNG-Transparente-Sem-Fundo-1.png',
  // Updated tour video URL (New one provided)
  tourVideo:
    'https://cdn.magicpatterns.com/uploads/f7rkCuu7Noq1j3MoT4bjF7/WhatsApp%20Video%202026-02-18%20at%2008.49.19.mp4',
  // New Product Bundle Image
  productBundle:
    'https://cdn.magicpatterns.com/uploads/kdfPTFxooEJbw5hCVqAFHA/a-professional-3d-digital-product-bundle_ZWwahOLvQf2Uu3rL64LDGw__hvQ1enOQvqSouI7YWo6DQ_hd.png',
}

export const PURCHASE_LINK =
  'https://checkout.motologicpro.shop/cart/47451153662173:1'

export const ALL_TESTIMONIALS = [
  {
    name: 'Javier M.',
    text: 'che muy bueno el curso, me sirvio una banda para empezar con el service de mi wave. se re entiende.',
    rating: 5,
  },
  {
    name: 'Lucas R.',
    text: 'Pensé que iba a ser mas dificil pero con los videos se entiende al toque. lo recomiendo de una.',
    rating: 5,
  },
  {
    name: 'Esteban D.',
    text: 'Excelente contenido, la parte eléctrica es muy completa pero hay que ver los videos con calma para no perderse. Mucha data junta.',
    rating: 4,
  },
  {
    name: 'Matías S.',
    text: 'lo empece hace 1 semana y ya le arregle el embrague a un vecino, ya recupere un poco de la inversión jaja.',
    rating: 5,
  },
  {
    name: 'Roberto F.',
    text: 'Espectacular, el manual pdf que viene de regalo es clave para tenerlo a mano en el taller.',
    rating: 5,
  },
  {
    name: 'Nicolás G.',
    text: 'Mucha información de valor, me llevó un par de días organizar todo el material pero vale totalmente la pena. No es mágico, hay que estudiar.',
    rating: 4,
  },
  {
    name: 'Facundo L.',
    text: 'estaba entre este y otro pero me decidi por este x la logica de taller y no me arrepiento, es otra cosa.',
    rating: 5,
  },
  {
    name: 'Gonzalo P.',
    text: 'Muy completo el curso. Yo no sabia ni cambiar una bujia y ahora ya estoy desarmando un motor 150.',
    rating: 5,
  },
  {
    name: 'Martín C.',
    text: 'Lo mejor es que podes ver los videos mil veces, yo me re trabo con la inyeccion pero ahora ya le agarre la mano.',
    rating: 5,
  },
  {
    name: 'Diego A.',
    text: 're bien explicado todo, se nota q saben un montón los profes. 10 de 10.',
    rating: 5,
  },
  {
    name: 'Ramiro T.',
    text: 'me sirvió mucho para mi emprendimiento, aca en el interior faltan mecanicos asi q tengo bocha de laburo.',
    rating: 5,
  },
  {
    name: 'Sebastián V.',
    text: 'Sinceramente me sorprendio la calidad de los videos, se ve todo perfecto.',
    rating: 5,
  },
  {
    name: 'Pablo H.',
    text: 'al principio dudaba de pagar por internet pero el acceso fue automatico, al minuto ya estaba viendo las clases.',
    rating: 5,
  },
  {
    name: 'Tomás B.',
    text: 'Che el bono de los diagramas es una masa, me salvo la vida con una instalacion electrica de una motomel.',
    rating: 5,
  },
  {
    name: 'Agustín N.',
    text: 'lo recomiendo para los que recien arrancan, te explican paso a paso sin vueltas.',
    rating: 5,
  },
  {
    name: 'Federico J.',
    text: 'todo joya, ya voy por la mitad del curso y aprendi mas q en 2 años mirando youtube.',
    rating: 5,
  },
  {
    name: 'Carlos W.',
    text: 'buenisimo el curso, muy practico todo. saludos desde cordoba!',
    rating: 5,
  },
  {
    name: 'Leandro K.',
    text: 'Lo compre ayer y ya me vi como 20 clases, te engancha xq es pura practica.',
    rating: 5,
  },
  {
    name: 'Hernán Q.',
    text: 'Faltaba un curso asi en argentina, bien criollo y directo al grano para ganar plata.',
    rating: 5,
  },
  {
    name: 'Ignacio Z.',
    text: 'Una maravilla como explican la parte de transmision, me quedo clarisimo.',
    rating: 5,
  },
  {
    name: 'Andrés O.',
    text: 'los manuales q vienen son un golazo, los tengo en el celu y los miro mientras laburo en la moto.',
    rating: 5,
  },
  {
    name: 'Santiago E.',
    text: 'excelente inversion, ya me ahorre banda de plata haciendo yo mismo el mantenimiento.',
    rating: 5,
  },
  {
    name: 'Damián U.',
    text: 'me encanto la parte de herramientas caseras, te enseñan a no gastar de mas al principio.',
    rating: 5,
  },
  {
    name: 'Maximiliano I.',
    text: 'Muy copado el soporte por telegram, te contestan todo.',
    rating: 5,
  },
  {
    name: 'Cristian Y.',
    text: 'le doy 5 estrellas xq es real lo de la logica de taller, te cambia la forma de ver el motor.',
    rating: 5,
  },
  {
    name: 'Emiliano X.',
    text: 'Al toque me llego el mail, ya soy alumno y estoy re manija con las clases.',
    rating: 5,
  },
  {
    name: 'Valentín R.',
    text: 'gracias por la buena onda, se nota que quieren que aprendamos de verdad.',
    rating: 5,
  },
  {
    name: 'Lautaro D.',
    text: 'muy bueno para salir del paso con reparaciones rapidas y ganar unos pesos extra.',
    rating: 5,
  },
  {
    name: 'Joaquín F.',
    text: 'La verdad q vale cada centavo, no duden si les gustan las motos.',
    rating: 5,
  },
  {
    name: 'Thiago M.',
    text: 'un antes y un despues este curso, ahora ya se lo que estoy haciendo cuando toco el motor.',
    rating: 5,
  },
]
